module.exports = __webpack_public_path__ + "static/media/STWire3.d755e802.png";